import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { ProductVial } from "@/components/ProductVial";
import { toast } from "sonner";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const soldOut = (product.stock ?? 0) <= 0;

  return (
    <div
      className="group fade-up rounded-xl border border-brand-navy/10 bg-white overflow-hidden hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(20,47,76,0.4)] transition-[transform,box-shadow] duration-300"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block relative">
        <div className="aspect-square bg-gradient-to-br from-brand-mist to-white flex items-center justify-center p-3 overflow-hidden">
          <ProductVial product={product} className={`w-full h-full group-hover:scale-[1.04] transition-transform duration-500 ${soldOut ? "opacity-50 grayscale" : ""}`} />
        </div>
        {soldOut ? (
          <span className="absolute top-3 left-3 font-mono-label text-[10px] uppercase tracking-[0.15em] bg-destructive text-white px-2.5 py-1 rounded-full" data-testid={`sold-out-${product.slug}`}>
            Sold Out
          </span>
        ) : product.best_seller && (
          <span className="absolute top-3 left-3 font-mono-label text-[10px] uppercase tracking-[0.15em] bg-brand-teal text-white px-2.5 py-1 rounded-full">
            Best Seller
          </span>
        )}
        <span className="absolute top-3 right-3 font-mono-label text-[10px] uppercase tracking-[0.12em] bg-white/90 text-brand-navy px-2.5 py-1 rounded-full border border-brand-navy/10">
          {product.purity}
        </span>
      </Link>

      <div className="p-5">
        <p className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-brand-blue">{product.category}</p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="mt-1.5 font-display text-lg text-brand-navy leading-tight hover:text-brand-blue transition-colors">{product.name}</h3>
        </Link>
        <p className="mt-1 text-sm text-brand-navy/55 line-clamp-2">{product.short}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="font-display text-2xl text-brand-navy">${product.price.toFixed(2)}</span>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            disabled={soldOut}
            onClick={() => {
              addItem(product);
              toast.success(`${product.name} added to cart`);
            }}
            className={`flex items-center gap-1.5 rounded-full text-sm font-semibold px-4 py-2 transition-colors ${soldOut ? "bg-brand-navy/15 text-brand-navy/40 cursor-not-allowed" : "bg-brand-navy hover:bg-brand-teal text-white"}`}
          >
            {soldOut ? "Sold Out" : (<><Plus className="h-4 w-4" /> Add</>)}
          </button>
        </div>
      </div>
    </div>
  );
};
